import { Colors } from '@constants/colors.constants';
import { Popover, Stack, Step, StepLabel, Stepper, Typography, styled } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export interface ActionModel {
  unitPriceInCents: number;
  by: string;
  date: string;
}

const StyledPopover = styled(Popover)({
  zIndex: 9999,
  '& .MuiPopover-paper': {
    backgroundColor: '#ECEDEE',
  },
});

const StyledStepper = styled(Stepper)({
  padding: '20px 20px',
  '& .MuiStepConnector-line': {
    borderLeftStyle: 'dashed',
    borderLeftWidth: '2px',
    borderLeftColor: 'rgba(0, 0, 0, 0.12)',
    right: '8px',
    position: 'relative',
  },
});

const Puce = styled('div')<{ full: boolean }>((props) => ({
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  backgroundColor: props.full ? '#192133' : 'transparent',
  border: props.full ? 'none' : '1px solid #192133',
  marginRight: '10px',
}));

interface HistoryPopoverProps {
  history: ActionModel[];
  anchorEl: null;
  open: boolean;
  onClose: () => void;
}

const HistoryPopover = (props: HistoryPopoverProps) => {
  const { history, anchorEl, open, onClose } = props;
  const { t } = useTranslation();

  return (
    <StyledPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      elevation={0}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <StyledStepper orientation="vertical">
        {history
          .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
          .map((item, index) => (
            <Step sx={{ alignItems: 'center', verticalAlign: 'top' }} key={index}>
              <StepLabel
                sx={{ alignItems: 'center', padding: '0px' }}
                StepIconComponent={() => (
                  <Puce full={history.length - 1 === index} />
                )}
              >
                <Stack flexDirection="row" alignItems='center' justifyContent="space-between" width="100%" sx={{ minWidth: '400px' }}>
                  <Stack flexDirection="column" alignItems="flex-start">
                    {history.length - 1 === index ? (
                      <Typography fontSize="14px" fontWeight={500} color="#192133">
                        {t('audits.auditOfferFollowUp.modal.detailsOffer.popover.initialPrice')}
                      </Typography>
                    )
                      :
                      (<Typography fontSize="14px" fontWeight={index === 0 ? 800 : 500} color="#192133">
                        {t('audits.auditOfferFollowUp.modal.detailsOffer.popover.modifiedBy', { value: item.by })}
                      </Typography>)}
                    {item.date && (
                      <Typography fontSize="12px" fontWeight={350} color={Colors.lightGrey} textAlign={'right'}>
                        {t('audits.auditOfferFollowUp.modal.detailsOffer.popover.date', { value: dayjs(item.date).format('DD.MM.YYYY') })}
                      </Typography>
                    )}
                  </Stack>
                  <Typography fontSize="14px" fontWeight={index === 0 ? 800 : 500} color="#192133">
                    {item.unitPriceInCents / 100} CHF
                  </Typography>
                </Stack>
              </StepLabel>
            </Step>
          ))}
      </StyledStepper>
    </StyledPopover>
  );
};

export default HistoryPopover;